/**
 * Shared page chrome for Portfolio, Engagement, and Studio.
 */
export default function NexusSurfaceShell({
  surfaceId = "default",
  eyebrow,
  title,
  subtitle,
  lenses = [],
  activeLens,
  onLensChange,
  actions = null,
  stats = null,
  signals = null,
  children,
}) {
  return (
    <div className={`nexus-surface nexus-surface--${surfaceId}`}>
      <div className="nexus-surface-bg" aria-hidden />
      <div className="nexus-surface-mesh" aria-hidden />
      <div className="nexus-surface-scanline" aria-hidden />
      <div className="nexus-surface-glow nexus-surface-glow--brand" aria-hidden />
      <div className="nexus-surface-glow nexus-surface-glow--cyan" aria-hidden />

      <div className="nexus-surface-inner">
        <header className="nexus-surface-header">
          <div className="nexus-surface-header-main min-w-0">
            {eyebrow ? <p className="nexus-surface-eyebrow">{eyebrow}</p> : null}
            <h1 className="nexus-surface-title">
              <span className="nexus-surface-title-gradient">{title}</span>
            </h1>
            {subtitle ? <p className="nexus-surface-subtitle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="nexus-surface-actions shrink-0">{actions}</div> : null}
        </header>

        {signals ? <div className="nexus-surface-signals">{signals}</div> : null}

        {stats ? <div className="nexus-surface-stats">{stats}</div> : null}

        {lenses.length > 0 ? (
          <div className="nexus-lens-bar" role="tablist" aria-label={`${title} views`}>
            {lenses.map((lens) => {
              const active = activeLens === lens.id;
              return (
                <button
                  key={lens.id}
                  type="button"
                  role="tab"
                  aria-selected={active}
                  className={`nexus-lens-tab${active ? " nexus-lens-tab--active" : ""}`}
                  onClick={() => onLensChange?.(lens.id)}
                >
                  {lens.icon ? (
                    <span className="nexus-lens-tab-icon" aria-hidden>
                      {lens.icon}
                    </span>
                  ) : null}
                  <span className="nexus-lens-tab-text">
                    <span className="nexus-lens-tab-label">{lens.label}</span>
                    {lens.desc ? (
                      <span className="nexus-lens-tab-desc">{lens.desc}</span>
                    ) : null}
                  </span>
                  {active ? <span className="nexus-lens-tab-glow" aria-hidden /> : null}
                </button>
              );
            })}
          </div>
        ) : null}

        <div className="nexus-glass-panel">
          <div className="nexus-glass-panel-accent" aria-hidden />
          <div className="nexus-surface-body" role="tabpanel">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export function SurfaceStatCard({ label, value, hint, href, onClick, active }) {
  const inner = (
    <>
      <span className="nexus-stat-label">{label}</span>
      <span className="nexus-stat-value">{value ?? "—"}</span>
      {hint ? <span className="nexus-stat-hint">{hint}</span> : null}
    </>
  );

  const className = `nexus-stat-card${active ? " nexus-stat-card--active" : ""}`;

  if (href) {
    return (
      <a href={href} className={className}>
        {inner}
      </a>
    );
  }

  return (
    <button type="button" className={className} onClick={onClick}>
      {inner}
    </button>
  );
}
